import React, { useEffect, useState } from 'react';
import {
    ActionButton, Dialog, DialogType, DialogFooter, TextField, DefaultButton, PrimaryButton,
    CommandBarButton, IconButton, IButtonStyles, TooltipHost, IOverflowSetItemProps, Checkbox, Icon
} from '@fluentui/react';
import DataTable from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { useModalContext } from '../components/ModalProvider';
import { from, MarketplaceOffer } from '@the-real-insight/tri-model';
import { userAPI } from '../UserAPI';
import { AgentToolset } from '@the-real-insight/tri-model';
import MarketingDetails from './MarketingDetails';
import PlanPanel from './PlanPanel';
import { useAtom } from 'jotai';
import { authenticationAtom } from '../State';
import LoadingIndicator from '../components/LoadingIndicator';
import { useTestDialog } from './hooks/useTestDialog';
import SampleRequests from './SampleRequests';
import { MCPClient } from '@the-real-insight/tri-model';

const dummyAgentToolsets = [{ _type: 'AgentToolset', _id: '1', serverURL: 'http://localhost:3066', name: 'Testserver', published: true, offered: true }];

interface AgentToolsetProps {
}

export default function AgentToolsetManagement({
}: AgentToolsetProps) {
    const { t } = useTranslation();
    const [authentication] = useAtom(authenticationAtom) as any;
    const { pushError, showDeleteDialog } = useModalContext() as any;
    const { TestDialog, openTestDialog, closeTestDialog } = useTestDialog();
    const [agentToolsets, setAgentToolsets] = useState<any[]>([]);
    const [loadingAgentToolsets, setLoadingAgentToolsets] = useState(false);
    const [marketplaceOffer, setMarketplaceOffer] = useState<any>(null);
    const [selectedKey, setSelectedKey] = useState('general');
    const menuItems = [
        { key: 'general', name: 'Allgemein' },
        { key: 'server', name: 'MCP-Server' },
        { key: 'sampleRequests', name: 'Beispielanfragen' },
        { key: 'details', name: 'Details' },
        { key: 'billing', name: 'Abrechnung' }
    ];

    const agentToolsetColumns = [{
        name: '',
        width: '120px',
        cell: (server: any) => <div className='flexGrow1 displayFlex justifyContentCenter'>
            <TooltipHost content="Bearbeiten">
                <ActionButton iconProps={{ iconName: 'Edit' }} onClick={() => setMarketplaceOffer(server)}></ActionButton>
            </TooltipHost>
            <TooltipHost content="Testen">
                <ActionButton iconProps={{ iconName: 'Rocket' }} onClick={() => openTestDialog(server)}></ActionButton>
            </TooltipHost>
            <TooltipHost content="Löschen">
                <ActionButton iconProps={{ iconName: 'Delete' }} styles={{ icon: { color: 'red' } }} onClick={() => {
                    showDeleteDialog(`MCP-Server ${server.name} löschen`,
                        server.name,
                        async () => {
                            await userAPI.deleteMarketplaceOffer(authentication.customer, server);
                        });
                }}></ActionButton>
            </TooltipHost>
        </div>
    }, {
        width: '200px',
        name: 'Name',
        cell: (server: any) => <div>{server.name}</div>
    }, {
        width: '400px',
        name: 'Beschreibung',
        cell: (server: any) => <div>{server.synopsis}</div>
    }, {
        width: '200px',
        name: 'Intern verfügbar',
        cell: (server: any) => <div className='flexGrow1 displayFlex justifyContentCenter'>{server.published ?
            <div><Icon iconName='CheckMark' /></div>
            :
            <div><Icon iconName='Cancel' /></div>
        }</div>
    }, {
        width: '200px',
        name: 'Im Marktplatz angeboten',
        cell: (server: any) => <div className='flexGrow1 displayFlex justifyContentCenter'>{server.offered ?
            <div><Icon iconName='CheckMark' /></div>
            :
            <div><Icon iconName='Cancel' /></div>
        }</div>
    }, {
        name: 'Server URL',
        cell: (server: any) => <div>{server.serverURL}</div>
    }];

    const onImagesChange = async (imageList: any, addUpdateIndex: any) => {
        try {
            // TODO put in API function

            const form = new FormData();

            form.append("file", imageList[0].file);

            const image = await userAPI.uploadFile(form);

            console.log('image', image);

            setMarketplaceOffer({ ...marketplaceOffer, images: [...marketplaceOffer.images, image.path] });
        } catch (error: any) {
            pushError(error);
        }
    };

    const loadAgentToolsets = async () => {
        try {
            setLoadingAgentToolsets(true);

            const agentToolsets = await userAPI.query(from(AgentToolset.type));

            setAgentToolsets(agentToolsets);
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingAgentToolsets(false);
        }
    }

    useEffect(() => {
        const call = async () => {
            if (!marketplaceOffer) {
                loadAgentToolsets();
            } else {
                const mcpClient = new MCPClient(marketplaceOffer.serverURL);

                try {
                    await mcpClient.connect();

                    const tools = await mcpClient.listTools();

                    console.log('tools', tools);
                } catch (error) {
                    console.log('error', error);
                } finally {
                    mcpClient.disconnect();
                }
            }
        }

        call();
    }, [marketplaceOffer]);

    return (
        <>
            {marketplaceOffer
                ?
                <div>
                    <div className="displayFlex alignItemsCenter">
                        <div>
                            <div className="textS">Agent Toolset</div>
                            <div className="textHeading">{marketplaceOffer.name}</div>
                        </div>
                        <div className="flexGrow1 displayFlex justifyContentEnd gapM">
                            <DefaultButton className="marginTopM" onClick={() => {
                                setMarketplaceOffer(null);
                            }}>Abbrechen</DefaultButton>
                            {marketplaceOffer._id ?
                                <PrimaryButton className="marginTopM" onClick={async () => {
                                    console.log('marketplaceOffer', marketplaceOffer);
                                    await userAPI.updateMarketplaceOffer(authentication.customer, marketplaceOffer);
                                    setMarketplaceOffer(null);
                                }}>Speichern</PrimaryButton>
                                :
                                <PrimaryButton className="marginTopM" onClick={async () => {
                                    console.log('Create toolset', marketplaceOffer);
                                    await userAPI.createMarketplaceOffer(authentication.customer, marketplaceOffer);
                                    setMarketplaceOffer(null);
                                }}>Erstellen</PrimaryButton>
                            }
                        </div>
                    </div>
                    <div className="marginTopM displayFlex gapM">
                        <Checkbox label="Intern verfügbar" checked={marketplaceOffer.published} onChange={(e, value) => {
                            const newAgentToolSet = new AgentToolset({ ...marketplaceOffer, published: value });
                            setMarketplaceOffer(newAgentToolSet);
                        }} />
                        <Checkbox label="Im Marktplatz angeboten" checked={marketplaceOffer.offered} onChange={(e, value) => {
                            const newAgentToolSet = new AgentToolset({ ...marketplaceOffer, offered: value });
                            setMarketplaceOffer(newAgentToolSet);
                        }} />
                    </div>
                    <div className="marginTopL width1000 displayFlex gapM">
                        <div style={{ minWidth: '200px', maxWidth: '200px' }}>
                            {menuItems.map((item) => (
                                <div key={item.key} className={`paddingS displayFlex alignItemsCenter hoverHand ${selectedKey === item.key ? 'backgroundColorLightestGrey' : ''}`} onClick={() => setSelectedKey(item.key)}>
                                    {/* <Icon iconName={item.icon} /> */}
                                    <div>{item.name}</div>
                                </div>
                            ))}
                        </div>
                        <div>
                            {(() => {
                                switch (selectedKey) {
                                    case 'general':
                                        return (
                                            <div className="width600">
                                                <div>
                                                    <TextField
                                                        label="Name des Agent Toolsets"
                                                        value={marketplaceOffer.name}
                                                        onChange={(e, value) => {
                                                            setMarketplaceOffer({ ...marketplaceOffer, name: value });
                                                        }}
                                                    />
                                                </div>
                                                <div className="marginTopS">
                                                    <TextField
                                                        label="Beschreibung des Agent Toolsets"
                                                        value={marketplaceOffer.synopsis}
                                                        multiline
                                                        rows={5}
                                                        onChange={(e, value) => {
                                                            setMarketplaceOffer({ ...marketplaceOffer, synopsis: value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    case 'server':
                                        return (
                                            <div className="width600 displayFlex gapM alignItemsEnd">
                                                <div className="flexGrow1">
                                                    <TextField
                                                        label="MCP-Server URL"
                                                        value={marketplaceOffer.serverURL}
                                                        onChange={(e, value) => {
                                                            setMarketplaceOffer({ ...marketplaceOffer, serverURL: value });
                                                        }}
                                                    />
                                                </div>
                                                <TooltipHost content="MCP-Server testen">
                                                    <ActionButton iconProps={{ iconName: 'Rocket' }} onClick={() => { }}></ActionButton>
                                                </TooltipHost>
                                            </div>
                                        );
                                    case 'sampleRequests':
                                        return (
                                            <SampleRequests
                                                type={AgentToolset.type}
                                                marketplaceOffer={marketplaceOffer as MarketplaceOffer}
                                                setMarketplaceOffer={setMarketplaceOffer}
                                            />
                                        );
                                    case 'details':
                                        return (
                                            <MarketingDetails
                                                type={AgentToolset.type}
                                                marketplaceOffer={marketplaceOffer as MarketplaceOffer}
                                                setMarketplaceOffer={setMarketplaceOffer}
                                                onImagesChange={onImagesChange}
                                            />
                                        );
                                    case 'billing':
                                        return (
                                            <PlanPanel
                                                type={AgentToolset.type}
                                                marketplaceOffer={marketplaceOffer as MarketplaceOffer}
                                                setMarketplaceOffer={setMarketplaceOffer}
                                            />
                                        );
                                    default:
                                        return null;
                                }
                            })()}
                        </div>
                    </div>
                </div>
                :
                <div className='marginTopM'>
                    <ActionButton
                        className='marginTopM'
                        iconProps={{ iconName: 'Add' }}
                        onClick={async () => {
                            const newAgentToolset = new AgentToolset({
                                name: 'Neuer Agenten-Werkzeugsatz (REAL GAIN/MCP-Server)',
                                serverURL: '',
                            });
                            setMarketplaceOffer(newAgentToolset);
                        }}
                    >
                        Agenten-Werkzeugsatz (REAL GAIN/MCP-Server) hinzufügen
                    </ActionButton>
                    <div className='marginTopM borderNeutral'>
                        <DataTable
                            data={agentToolsets}
                            columns={agentToolsetColumns}
                            pagination
                            noDataComponent={loadingAgentToolsets ? <LoadingIndicator loading={true} text={'Lade Toolsets...'}></LoadingIndicator> : <div className='paddingL'>Keine Toolsets gefunden</div>}
                        />
                    </div>
                </div>
            }
            <TestDialog />
        </>
    );
} 